/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_TabInputs */



/**
* | output |
* | --- |
* | "Subscription" |
*
* @param {Subscription_TabInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subscription_tab = /** @type {((inputs?: Subscription_TabInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_TabInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Abonnement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Abonnement")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottoscrizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подписка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Suscripción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("订阅")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サブスクリプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सदस्यता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Subscrição")
	return /** @type {LocalizedString} */ ("Subscription")
});